/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const _pagepath = '/experience/';

	const experienceVoiceSlider = () => {
		const galleryElement = document.querySelector('.experience-voice-slider');
		if (!galleryElement) return; // 要素が存在しない場合は早期リターン

		var experienceVoiceSliderElement = document.querySelector('.experience-voice-slider');
		if (experienceVoiceSliderElement) {
			var experienceVoiceSlider = new Splide('.experience-voice-slider', {
				type: 'loop',
				perPage: 4.5,
				perMove: 1,
				autoplay: true,
				center: true,
				focus: 'center',
				gap: '8px',
				interval: 5000,
				speed: 500,
				arrows: true,
				pagination: true,
				paginationKeyboard: true,
				breakpoints: {
					1024: {
						perPage: 1.5,
						gap: '8px',
						focus: 'center', // 中央表示を維持
					},
				},
			});
			try {
				experienceVoiceSlider.mount();
				console.log('experienceVoiceSlider initialized successfully');
			} catch (error) {
				console.error('Error initializing experienceVoiceSlider:', error);
			}
		}
	};

	const experienceVoiceAccordion = () => {
		const accordions = document.querySelectorAll('[data-voice-accordion]');
		
		accordions.forEach(accordion => {
			const toggleBtn = accordion.querySelector('.experience-voice-accordion-toggle');
			const content = accordion.querySelector('.experience-voice-accordion-content');
			const preview = accordion.querySelector('.experience-voice-accordion-preview');
			const toggleText = accordion.querySelector('.toggle-text');
			const plus = accordion.querySelector('.experience-voice-accordion-plus');
			
			if (toggleBtn && content && preview && toggleText && plus) {
				// 初期設定：previewとcontentのテキストを結合
				const previewText = preview.querySelector('p').innerHTML;
				const contentText = content.querySelector('p').innerHTML;
				const fullText = previewText + contentText;
				
				// previewのpタグに結合したテキストを設定
				const combinedP = preview.querySelector('p');
				combinedP.innerHTML = fullText;
				
				// contentを非表示に
				content.style.display = 'none';

				// fullTextの行数をチェックして3行以内ならtoggleBtnを非表示
				requestAnimationFrame(() => {
					// 一時的にline-clampを解除して正確な高さを測定
					const originalLineClamp = combinedP.style.webkitLineClamp;
					const originalDisplay = combinedP.style.display;
					const originalBoxOrient = combinedP.style.webkitBoxOrient;
					const originalOverflow = combinedP.style.overflow;
					
					combinedP.style.webkitLineClamp = 'unset';
					combinedP.style.display = 'block';
					combinedP.style.webkitBoxOrient = 'initial';
					combinedP.style.overflow = 'visible';
					
					const lineHeight = parseFloat(getComputedStyle(combinedP).lineHeight);
					const height = combinedP.getBoundingClientRect().height;
					const lineCount = Math.round(height / lineHeight);
					
					// スタイルを元に戻す
					combinedP.style.webkitLineClamp = originalLineClamp || '3';
					combinedP.style.display = originalDisplay || '-webkit-box';
					combinedP.style.webkitBoxOrient = originalBoxOrient || 'vertical';
					combinedP.style.overflow = originalOverflow || 'hidden';
					
					if (lineCount <= 3) {
						toggleBtn.style.display = 'none';
					}
				});
				
				toggleBtn.addEventListener('click', () => {
					const isOpen = accordion.classList.contains('is-open');
					
					if (isOpen) {
						// 閉じる処理
						accordion.classList.remove('is-open');
						toggleText.textContent = '続きを見る';
						plus.classList.remove('is-open');
						
						// previewのpタグをクランプ表示に戻す
						combinedP.style.webkitLineClamp = '3';
						combinedP.style.display = '-webkit-box';
						combinedP.style.webkitBoxOrient = 'vertical';
						combinedP.style.overflow = 'hidden';
					} else {
						// 開く処理
						accordion.classList.add('is-open');
						toggleText.textContent = '閉じる';
						plus.classList.add('is-open');
						
						// previewのpタグを全文表示
						combinedP.style.webkitLineClamp = 'unset';
						combinedP.style.display = 'block';
						combinedP.style.overflow = 'visible';
					}
				});
			}
		});
	};

	const experienceVoiceItemAccordion = () => {
		const voiceItems = document.querySelectorAll('.experience-voice-item-txt');
		
		voiceItems.forEach(item => {
			const hideElement = item.querySelector('.__hide');
			const moreElement = item.querySelector('.__more');
			
			if (hideElement && moreElement) {
				// 初期設定
				hideElement.style.display = 'none';
				hideElement.style.opacity = '0';
				
				// プラスアイコンを追加
				const plusIcon = document.createElement('span');
				plusIcon.className = 'voice-item-plus';
				plusIcon.innerHTML = '';
				moreElement.appendChild(plusIcon);
				
				item.addEventListener('click', () => {
					const isOpen = item.classList.contains('is-open');
					
					if (isOpen) {
						// 閉じる処理
						item.classList.remove('is-open');
						moreElement.textContent = '続きを見る';
						moreElement.appendChild(plusIcon);
						plusIcon.classList.remove('is-open');
						
						// フェードアウト
						hideElement.style.opacity = '0';
						setTimeout(() => {
							hideElement.style.display = 'none';
						}, 300);
					} else {
						// 開く処理
						item.classList.add('is-open');
						moreElement.textContent = '閉じる';
						moreElement.appendChild(plusIcon);
						plusIcon.classList.add('is-open');
						
						// フェードイン
						hideElement.style.display = 'block';
						setTimeout(() => {
							hideElement.style.opacity = '1';
						}, 10);
					}
				});
			}
		});
	};

	const experiencePointSwiper = () => {
		const pointGalleryElement = document.querySelector('.experience-point-gallery');
		if (!pointGalleryElement) return; // 要素が存在しない場合は早期リターン

		const splide = new Splide('.experience-point-gallery.splide', {
			type: 'loop',
			perPage: 1,
			perMove: 1,
			autoplay: true,
			center: true,
			focus: 'center',
			gap: '8px',
			interval: 5000,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			focus: 'center',
			destroy: true,
			breakpoints: {
				1024: {
					destroy: false,
				},
			},
		}).mount();
		// const galleryElement = document.querySelector('.experience-point-gallery');
		// if (!galleryElement) return; // 要素が存在しない場合は早期リターン

		// var experienceGalleryElement = document.querySelector('.experience-point-gallery');
		// if (experienceGalleryElement) {
		// 	var experienceGallery = new Splide('.experience-point-gallery', {
		// 		type: 'loop',
		// 		perPage: 1.3,
		// 		perMove: 1,
		// 		autoplay: true,
		// 		gap: '20px',
		// 		interval: 5000,
		// 		speed: 500,
		// 		arrows: true,
		// 		pagination: true,
		// 		paginationKeyboard: true,
		// 		focus: 'center', // 中央表示を維持
		// 		// destroy: true,
		// 		breakpoints: {
		// 			1024: {
		// 				// destroy: false,
		// 			},
		// 		},
		// 	});
		// 	try {
		// 		experienceGallery.mount();
		// 		console.log('experienceGallery initialized successfully');
		// 	} catch (error) {
		// 		console.error('Error initializing experienceGallery:', error);
		// 	}
		// }
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const experienceFUNCTIONS = () => {
		experienceVoiceSlider();
		experienceVoiceAccordion();
		experienceVoiceItemAccordion();
		experiencePointSwiper();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { experienceFUNCTIONS(); }) : experienceFUNCTIONS();

})(window.FUNCTIONS);
